import { createContext, useContext, useState } from 'react'
import { LoginFlowContext } from '@nv/contexts'
import { AdminVoterAuthService } from '@nv/services'
import { useNavigate } from 'react-router-dom'

export const SessionTimerContext = createContext()

export const SessionTimerProvider = ({ children }) => {
  const [extendSession, setExtendSession] = useState(false)
  const [sessionEnding, setSessionEnding] = useState(false)

  const navigate = useNavigate()
  const LOGIN_CONTEXT = useContext(LoginFlowContext)

  const doExtendSession = async () => {
    await AdminVoterAuthService.extendSession()
  }
  const endSession = async () => {
    try {
      await AdminVoterAuthService.logOut(navigate)
      LOGIN_CONTEXT.setLoginFlow('Admin Login')
    } catch (error) {
      //console.log(error)
    }
  }
  return (
    <SessionTimerContext.Provider
      value={{
        extendSession,
        setExtendSession,
        sessionEnding,
        setSessionEnding,
        doExtendSession,
        endSession,
      }}
    >
      {children}
    </SessionTimerContext.Provider>
  )
}

export const useSessionTimer = () => {
  const context = useContext(SessionTimerContext)
  if (!context) {
    return ''
    //throw new Error(PROVIDER_ERROR)
  }
  return context
}

export default SessionTimerContext
